import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { SortMenu } from '../../shared/models/sort-menu';
import { FilterMenu } from '../../shared/models/filter-menu';
import { PanelList } from '../../shared/models/panel-list';
import { DocumentDetailDto } from '../../shared/models/document-details-dto';
import { ChangeRequestItemService } from '../services/change-request-item.service';
import { ChangeRequestItem } from '../models/change-request-item';
import { UpdateChangeRequestItem } from '../models/update-change-request-item';
import { MessageService } from 'primeng/api';
import { ChangeRequestConstants } from '../change-request.constants';
import { DocumentService } from '../../document/services/document.service';
import { CommonService } from '../../shared/services/common.service';

@Component({
  selector: 'app-change-request-history-modal',
  templateUrl: './change-request-history-modal.component.html',
  styleUrls: ['./change-request-history-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ChangeRequestHistoryModalComponent implements OnInit, OnChanges {
  @Input() documentDetailsDto!: DocumentDetailDto;
  @Input() isChangeRequestHistoryModalShow!: boolean;
  @Input() isLatestVersion!: boolean;
  @Input() documentPhase!: string;
  @Output() isCloseChangeRequestItemHistoryModal = new EventEmitter<boolean>();
  @Output() isLatestDocument = new EventEmitter<boolean>();
  @Output() isAllCRIStatusRejected = new EventEmitter<boolean>();
  @Input() isTriggeredFromReview: boolean=false;
  @Input() isTriggeredFromApproval: boolean=false;
  @Output() isReviewStatusModalVisible=new EventEmitter<boolean>();
  @Output() isApprovalStatusModalVisible=new EventEmitter<boolean>();
  @Input() showCRIReviewActionButtons!: boolean;
  @Input() checkedOutUserStatus!: boolean;

  readonly approveButtonTooltipMessage =
    ChangeRequestConstants.ChangeRequestItem_HistoryModal_Approve_Button_Tooltip_Message;
  readonly readyForApprovalButtonTooltipMessage =
    ChangeRequestConstants.ChangeRequestItem_HistoryModal_Delayed_Approval_Button_Tooltip_Message;
  readonly deferButtonTooltipMessage =
    ChangeRequestConstants.ChangeRequestItem_HistoryModal_Defer_Button_Tooltip_Message;
  rejectButtonTooltipMessage =
    ChangeRequestConstants.ChangeRequestItem_HistoryModal_Reject_Button_Tooltip_Message;
    readonly periodicReviewCRIRejectButtonTooltipMessage =
    ChangeRequestConstants.ChangeRequestItem_HistoryModal_Reject_Periodic_Review_CRI_Button_Tooltip_Message;
  readonly changeRequestItemEmptyMessage =
    ChangeRequestConstants.ChangeRequestItem_Empty_Message;
    readonly proceedAndDeferButtonTooltipMessage =
    ChangeRequestConstants.ChangeRequestItem_HistoryModal_DeferAndProceed_Button_Tooltip_Message;
    readonly changeRequestItemReviewStaticMessage=
    ChangeRequestConstants.Change_RequestItem_Review_Static_Message;
    readonly changeRequestItemApprovalStaticMessage=
    ChangeRequestConstants.Change_RequestItem_Approval_Static_Message;
  readonly phasesForChangeRequestItemDelayedButtonVisible = [
    'Effective',
    'Obsolete',
    'Archived',
  ];
  readonly phasesForChangeRequestItemDeferButtonHide = [
    'Effective',
    'Obsolete',
    'Archived',
  ];
  isChangeRequestDataLoaded: boolean = false;
  changeRequestItems: any;
  changeRequestPanelListInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableSelection: true,
  };
  isRejectChangeRequestModal: boolean = false;
  isRejectPeriodicChangeRequestModal: boolean = false;
  isPeriodicApprovalModal: boolean = false;
  isDelayedApprovalBtnVisible: boolean = false;
  isDeferBtnVisible: boolean = false;
  crSelectedItems: ChangeRequestItem[] = [];
  btnDisabled: boolean = true;
  approvebtnDisabled: boolean = true;
  isMsgModalVisible: boolean = false;
  msgTxt!: string;
  headerMsgTxt: string = ChangeRequestConstants.ReviewerCommentHeader;
  isFooterButtonsVisible: boolean = false;
  isCreateNewVersion: boolean = false;
  displayStaticMessageForCRIDuringReview:boolean=false;
  displayStaticMessageForCRIDuringApproval:boolean=false;
  displayProceedBtn:boolean=false;
  displayDeferAndProceedBtn:boolean=false;
  changeRequestItemsToBeDisplayed:ChangeRequestItem[]=[];
  displayDelayedApprovalButtonForAutomatedCRI=false;
  displayDefferedButtonForAutomatedCRI=false;
  displayRejectButtonForAutomatedCRI=false;
  isPeriodicChangeRequestSelected=false;
  criPeriodcReviewDate:any;
  periodicReviewChangeRequestItemType=ChangeRequestConstants.PeriodicReviewChangeRequestItemType;
  isApprovalBtnVisible: boolean = false;
  isRejectBtnVisible:boolean = false;
  noData: boolean = false;
  showLoader: boolean = false;

  constructor(
    private changeRequestItemService: ChangeRequestItemService,
    private messageService: MessageService,
    private documentService:DocumentService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.verifyAndSetDelayedApprovalButton();
    this.verifyAndSetDeferedButton();
    this.isFooterButtonsVisible =
      this.isLatestVersion || this.documentPhase == 'Effective';
    this.isApprovalBtnVisible=true;
    this.isRejectBtnVisible = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getChangeRequestItems(
      changes['isChangeRequestHistoryModalShow'].currentValue
    );
  }
  verifyAndSetDeferedButton()
  {
    if (
      (this.phasesForChangeRequestItemDeferButtonHide.indexOf(
        this.documentPhase
      ) === -1 &&
        this.isLatestVersion == true) ||
      (this.documentPhase == 'Effective' && this.isLatestVersion == false)
    ) {
      this.isDeferBtnVisible = true;
    }
    else{
      this.isDeferBtnVisible = false;
    }
  }
  verifyAndSetDelayedApprovalButton()
  {
    if (
      this.isLatestVersion == true &&
      this.phasesForChangeRequestItemDelayedButtonVisible.indexOf(
        this.documentPhase
      ) !== -1
    ) {
      this.isDelayedApprovalBtnVisible = true;
    }
    else
    {
      this.isDelayedApprovalBtnVisible = false;
    }
  }

  setButtonsAndMessagesForDocumentApprovalAndReview()
  {
    if(this.isTriggeredFromReview )
    {
      this.displayStaticMessageForCRIDuringReview=true;
      this.displayProceedBtn=true;
    }
    else if(this.isTriggeredFromApproval)
    {
      this.displayStaticMessageForCRIDuringApproval=true;
      this.displayDeferAndProceedBtn=true;
    }
  }

  getChangeRequestItems = (isShow: boolean) => {
    this.showLoader = true;
    this.changeRequestItemService
      .getChangeRequestItems(this.documentDetailsDto)
      .subscribe((changeRequestItemsData) => {
        this.changeRequestItemsToBeDisplayed = changeRequestItemsData
        this.changeRequestItemsToBeDisplayed.forEach(cri=>{
          if(!cri.changeRequestAuthorizationFlags?.enableCheckBoxesAndButtons && !cri.isLoggedInUserAssignedAdminOrPeriodicReviewer){
            this.disableCRICheckBoxAndButtons();
          }
            if(cri.changeRequestAuthorizationFlags?.criManualEnableCheckBox){
              this.enableCRICheckBoxAndFooter();
            }
            if(cri.changeRequestAuthorizationFlags?.criPeriodicEnableCheckBox){
              this.enableCRICheckBoxAndFooter();
            }
        })
        this.changeRequestPanelListInput.lists = this.changeRequestItemsToBeDisplayed;
        this.changeRequestPanelListInput.enableSelection =
          this.getVisibilityOfChangeRequestItemFooter();

        this.noData = this.commonService.IsListEmpty(this.changeRequestItemsToBeDisplayed);
        this.showLoader = false;
        this.changeRequestPanelListInput.filters =
          this.getFiltersForChangeRequestItems();
        this.changeRequestPanelListInput.sort =
          this.getSortFieldsForChangeRequestItems();
        this.isChangeRequestDataLoaded = true;
        this.setButtonsAndMessagesForDocumentApprovalAndReview();
      });
  };
  getFiltersForChangeRequestItems = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'Status',
        filterFieldName: 'status',
      },
      {
        filterDisplayName: 'Requested By',
        filterFieldName: 'requestedBy',
      },
      {
        filterDisplayName: 'Type',
        filterFieldName: 'changeRequestItemType',
      },
      {
        filterDisplayName: 'Reviewed By',
        filterFieldName:'reviewedBy'
      }
    );
    return filters;
  };
  getSortFieldsForChangeRequestItems = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'Item #',
        sortFieldName: 'ChangeRequestItemNumber',
      },
      { sortFieldDisplayName: 'Status', sortFieldName: 'status' },
      { sortFieldDisplayName: 'Type', sortFieldName: 'changeRequestItemType' },
      { sortFieldDisplayName: 'Description', sortFieldName: 'description' },
      {
        sortFieldDisplayName: 'Benefit Of Change',
        sortFieldName: 'benefitOfChange',
      },
      { sortFieldDisplayName: 'Requested By', sortFieldName: 'requestedBy' },
      { sortFieldDisplayName: 'Requested Date', sortFieldName: 'requestedDate' },
      { sortFieldDisplayName: 'Reviewed By', sortFieldName:'reviewedBy'}
    );
    return sortMenu;
  };
  calculateStatusColor = (status: string): string => {
    let statusColor = '';
    switch (status) {
      case 'Pending':
      case 'NextPeriodicReview':
        statusColor = 'grey-color';
        break;
      case 'Approved':
        statusColor = 'green-color';
        break;
      case 'Rejected':
        statusColor = 'red-color';
        break;
      case 'Deferred':
        statusColor = 'orange-color';
        break;
      case 'Delayed Approval':
        statusColor = 'blue-color';
        break;
    }
    return statusColor;
  };

  closeChangeRequestItemHistoryModal() {
    this.isChangeRequestHistoryModalShow = false;
    this.isChangeRequestDataLoaded = false;
    this.isCloseChangeRequestItemHistoryModal.emit(
      this.isChangeRequestHistoryModalShow
    );
    this.isLatestDocument.emit(this.isLatestVersion);

    let rejectedChangeRequestPanelListInput  = this.changeRequestPanelListInput.lists.filter((x : any)=> x.status == ChangeRequestConstants.RejectedStatus);
    if(rejectedChangeRequestPanelListInput.length === this.changeRequestPanelListInput.lists.length)
      this.isAllCRIStatusRejected.emit(true);
    else
      this.isAllCRIStatusRejected.emit(false);
  }

  openReasonforRejectionModal() {
    this.isRejectChangeRequestModal = true;
  }
  openPeriodicRejectionModal() {
    let data=this.crSelectedItems.some(obj=>obj.changeRequestItemType===ChangeRequestConstants.PeriodicReviewChangeRequestItemType);
    data?this.isRejectPeriodicChangeRequestModal = true:this.openReasonforRejectionModal();    
  }
  openPeriodicApprovalModal() {
    this.approvebtnDisabled = true;
    let data=this.crSelectedItems.some(obj=>obj.changeRequestItemType=== ChangeRequestConstants.PeriodicReviewChangeRequestItemType);
    if(typeof(data)!= "undefined" && data)
    {
      this.isPeriodicApprovalModal = true;
    }
    else
    {
      this.isPeriodicApprovalModal = false;
      this.updateStatus(ChangeRequestConstants.ApprovedStatus,'');
    }
   
  }

  closeRejectChangeRequestModal(event: any) {
    this.isRejectChangeRequestModal = false;
    //update panel data after rejection
    this.updatePanelData();
  }

  closeApproveChangeRequestModal(event: any) {
    this.isPeriodicApprovalModal = false;
    //update panel data after rejection
    this.updatePanelData();
  }

  closeRejectPeriodChangeRequestModal(event: any) {
    this.isRejectPeriodicChangeRequestModal = false;
    //update panel data after rejection
    this.updatePanelData();
  }
  closePeriodicCRIApprovalModal(event: any) {
    this.isPeriodicApprovalModal = false;
    //update panel data after rejection
    this.updatePanelData();
  }

  proceedToReviewDocument()
  {
    this.isChangeRequestHistoryModalShow=false;
    this.isCloseChangeRequestItemHistoryModal.emit(
      this.isChangeRequestHistoryModalShow
    );
    this.isReviewStatusModalVisible.emit(
      this.isChangeRequestHistoryModalShow
    );
  }

  deferAndproceedToAppoveDocument()
  {
    this.isChangeRequestHistoryModalShow=false;
    this.isCloseChangeRequestItemHistoryModal.emit(
      this.isChangeRequestHistoryModalShow
    );
    this.isApprovalStatusModalVisible.emit(
      this.isChangeRequestHistoryModalShow
    );
  }

  updateStatus(itemStatus: string,descriptionCommentForPeriodicCRIApproval:string) {
    let crItems: UpdateChangeRequestItem[] = [];
    let iscrItemVersionIsNew: boolean = this.crSelectedItems.some(
      (crItem) => crItem.documentVersion == this.documentDetailsDto.version
    );
    this.isCreateNewVersion =
      this.isLatestVersion &&
      itemStatus == ChangeRequestConstants.ApprovedStatus &&
      iscrItemVersionIsNew;
    
    this.crSelectedItems.forEach((x) => {
      crItems.push({
        changeRequestItemNumber:
          this.documentDetailsDto.number +
          '-v' +
          x.documentVersion +
          '-' +
          x.changeRequestItemNumber,
        status: itemStatus,
        isLatestVersion: this.isCreateNewVersion,
        documentNumber: this.documentDetailsDto.number,
        documentVersion: this.documentDetailsDto.version,
        periodicReviewDate:null,
        description:descriptionCommentForPeriodicCRIApproval,
        changeRequestItemType: x.changeRequestItemType || ''

      });
      x.status = itemStatus;
    });

    if (
      itemStatus == ChangeRequestConstants.ApprovedStatus &&
      this.isCreateNewVersion == true
    ) {
      this.changeRequestPanelListInput.lists.forEach((crItem: any) => {
        if (crItem.status == ChangeRequestConstants.DelayedApprovalStatus) {
          crItems.push({
            changeRequestItemNumber:
              this.documentDetailsDto.number +
              '-v' +
              crItem.documentVersion +
              '-' +
              crItem.changeRequestItemNumber,
            status: crItem.status,
            isLatestVersion: this.isCreateNewVersion,
            documentNumber: this.documentDetailsDto.number,
            documentVersion: this.documentDetailsDto.version,
            periodicReviewDate:null,
            description:descriptionCommentForPeriodicCRIApproval,
            changeRequestItemType: crItem.changeRequestItemType || ''
          });
        }
      });
    }
    this.changeRequestItemService.updateChangeRequestItems(crItems).subscribe({
      error: () =>
        this.messageService.add({
          severity: ChangeRequestConstants.Severity_Info,
          summary: `${ChangeRequestConstants.ErrorOnUpdate}`,
        }),
      complete: () => {
        let summaryInfo: string = '';
        switch (itemStatus) {
          case ChangeRequestConstants.ApprovedStatus:
            summaryInfo = `${ChangeRequestConstants.ChangeRequestItemApproved_success}`;
            break;
          case ChangeRequestConstants.DelayedApprovalStatus:
            summaryInfo = `${ChangeRequestConstants.ChangeRequestItemDelayedApproval_success}`;
            break;
          case ChangeRequestConstants.DeferredStatus:
            summaryInfo = `${ChangeRequestConstants.ChangeRequestItemDefered_success}`;
        }
        this.messageService.add({
          severity: ChangeRequestConstants.Severity_Info,
          summary: summaryInfo,
        });
        if (this.isCreateNewVersion == true) {
          this.messageService.add({
            severity: ChangeRequestConstants.Severity_Info,
            summary: ChangeRequestConstants.NewDocumentVersionCreated_success,
          });
        }
        if (
          itemStatus == ChangeRequestConstants.ApprovedStatus &&
          this.isLatestVersion == true
        )
          this.isLatestVersion = false;
        this.updatePanelData();
      },
    });
  }

  approvePeriodicReviewCRI(event:any){
    this.updateStatus(ChangeRequestConstants.ApprovedStatus,event);
  }

  getSelectedItems(selectedItems: any[]) {
    this.crSelectedItems = selectedItems;
    if (this.crSelectedItems.length > 0) {
      this.btnDisabled = false;
      this.approvebtnDisabled = false;
    }
    else{ this.btnDisabled = true;
          this.approvebtnDisabled = true;
      this.changeRequestPanelListInput.selectedChangeRequestItemType = '';
    }
    if (selectedItems.length > 0) {
      selectedItems.forEach(element => {
        if (element.changeRequestItemType != ChangeRequestConstants.ManualChangeRequestItemType) {
          if (element.isLoggedInUserAssignedAdminOrPeriodicReviewer || element.changeRequestAuthorizationFlags?.criPeriodicEnableCheckBox) {
            this.changeRequestPanelListInput.selectedChangeRequestItemType = element.changeRequestItemType;
            this.criPeriodcReviewDate = element.periodcReviewDate;
            this.setFooterButtonsForPeriodicReviewTypeChangeRequestItem();
            this.setRejectButtonToolTipForPeriodicReviewCRISelection();
          }
          else {
            this.setFooterButtonsOnPeriodicReviewTypeCRIForUnauthorizedUser();
          }
        }
        else if(element.changeRequestItemType == ChangeRequestConstants.ManualChangeRequestItemType){
          if(element.isLoggedInUserAssignedAdminOrAuthorOrApproverOrReviewer || element.changeRequestAuthorizationFlags?.criManualEnableCheckBox){
            this.changeRequestPanelListInput.selectedChangeRequestItemType = element.changeRequestItemType;
            this.setFooterButtonsForManualTypeChangeRequestItem();
          }
          else{
            this.setFooterButtonsForManualTypeCRIForUnauthorizedUser();
          }
        }
        else{
          this.changeRequestPanelListInput.selectedChangeRequestItemType = element.changeRequestItemType;
          this.setDefaultFooterButtonsInCRIHistoryModal();
        }
      });
    }
    else {
      this.setDefaultFooterButtonsInCRIHistoryModal();
    }
  }

  setFooterButtonsForManualTypeChangeRequestItem(){
    this.displayDelayedApprovalButtonForAutomatedCRI=true;
    this.displayDefferedButtonForAutomatedCRI=true;
    this.displayRejectButtonForAutomatedCRI=false;
  }

  setFooterButtonsForManualTypeCRIForUnauthorizedUser(){
    this.btnDisabled = true;
    this.approvebtnDisabled = true;
    this.setFooterButtonsForManualTypeChangeRequestItem();
  }

  setRejectButtonToolTipForPeriodicReviewCRISelection() {
    if (this.changeRequestPanelListInput.lists.filter((x: any) => x.status == ChangeRequestConstants.ApprovedStatus && x.changeRequestItemType===ChangeRequestConstants.ManualChangeRequestItemType ).length>0 
    && this.crSelectedItems.filter((x:any)=>x.changeRequestItemType===ChangeRequestConstants.PeriodicReviewChangeRequestItemType)) {
      this.displayRejectButtonForAutomatedCRI = true;
      this.rejectButtonTooltipMessage = ChangeRequestConstants.ChangeRequestItem_HistoryModal_Reject_Button_Tooltip_Message_For_Disabled_Button;
    }
    else {
      this.rejectButtonTooltipMessage = ChangeRequestConstants.ChangeRequestItem_HistoryModal_Reject_Button_Tooltip_Message_For_periodicReview;
    }
  }

  setDefaultFooterButtonsInCRIHistoryModal(){
    this.displayDelayedApprovalButtonForAutomatedCRI=true;
    this.displayDefferedButtonForAutomatedCRI=true;
    this.isPeriodicChangeRequestSelected=false;
    this.rejectButtonTooltipMessage=ChangeRequestConstants.ChangeRequestItem_HistoryModal_Reject_Button_Tooltip_Message
  }
  setFooterButtonsForPeriodicReviewTypeChangeRequestItem(){
    this.displayDelayedApprovalButtonForAutomatedCRI=false;
    this.displayDefferedButtonForAutomatedCRI=false;
    this.displayRejectButtonForAutomatedCRI=false;
    this.isPeriodicChangeRequestSelected=true;
  }
  setFooterButtonsOnPeriodicReviewTypeCRIForUnauthorizedUser(){
    this.btnDisabled=true;
    this.approvebtnDisabled = true;
    this.setFooterButtonsForPeriodicReviewTypeChangeRequestItem();
  }


  updatePanelData() {
    setTimeout(() => {
      this.changeRequestItemService
        .getChangeRequestItems(this.documentDetailsDto)
        .subscribe((changeRequestItemsData) => {
          this.changeRequestPanelListInput.lists = changeRequestItemsData;
  
          // Execute the code after the API call returns the result
          this.verifyAndSetDeferedButton();
          this.verifyAndSetDelayedApprovalButton();
          this.changeRequestPanelListInput.clearSelection = true;
          this.changeRequestPanelListInput = { ...this.changeRequestPanelListInput };
          this.changeRequestPanelListInput.enableSelection =
            this.getVisibilityOfChangeRequestItemFooter();

        });
    }, 1000);
  }

  openMessageModal = (msg: string) => {
    this.isMsgModalVisible = true;
    this.msgTxt = msg;
  };

  closeMsgModal = () => {
    this.isMsgModalVisible = false;
    this.msgTxt = '';
  };
  getVisibilityOfChangeRequestItemFooter = (): boolean => {
    return (
      this.isFooterButtonsVisible &&
      this.changeRequestPanelListInput.lists?.length > 0
    );
  };

  enableCRICheckBoxAndFooter(){
    this.changeRequestPanelListInput.enableSelection = true;
    this.isApprovalBtnVisible=true;
    this.isRejectBtnVisible=true;
    this.verifyAndSetDelayedApprovalButton();
    this.verifyAndSetDeferedButton();
  }

  disableCRICheckBoxAndButtons(){
    this.changeRequestPanelListInput.enableSelection = false;
    this.isApprovalBtnVisible=false;
    this.isRejectBtnVisible=false;
    this.isDelayedApprovalBtnVisible=false;
    this.isDeferBtnVisible = false;
  }

  getCheckOutUserStatus(){
    if(!this.checkedOutUserStatus)
      return true;
    if(this.showCRIReviewActionButtons){
      this.enableCRICheckBoxAndFooter();
      return true;
    }
    this.disableCRICheckBoxAndButtons();
    return false;
  }
}
